import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ISetting } from '../settings.interface';
import { SettingsService } from '../settings.service';
import * as _ from 'lodash';
import { AuthService } from '../../../../shared/services/auth.service';

let self: any;

@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.css']
})
export class SettingsModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  setting!: ISetting;
  form!: UntypedFormGroup;
  submitted = false;
  isDev!: boolean;

  constructor(
    public _SettingsService: SettingsService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');
    if (this.setting._id) this.getSetting();
    else this.buildForm();
  }

  getSetting() {
    this.loading = true;
    this._SettingsService.getSetting(this.setting._id || '').subscribe((setting) => {
      this.setting = setting;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      _id: [this.setting._id],
      code: [this.setting.code, [Validators.required]],
      name: [this.setting.name, [Validators.required]],
      defaultValue: [this.setting.defaultValue, [Validators.required]],
      isDeleted: [this.setting.isDeleted]
    });
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: ISetting = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    if (this.setting._id) {
      data._id = this.setting._id;
      this._SettingsService.updateSetting(data).subscribe((setting) => {
        this.dialog.close(setting);
      });
    } else {
      this._SettingsService.createSetting(data).subscribe((setting) => {
        this.dialog.close(setting);
      });
    }
  }
}